import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";

const Separator = forwardRef(
  (
    {
      className,
      orientation = "horizontal",
      decorative = true,
      ...props
    },
    ref
  ) => {
    const baseClasses = orientation === "horizontal" 
      ? "h-px w-full" 
      : "h-full w-px";
    
    return (
      <div
        ref={ref}
        role={decorative ? "none" : "separator"}
        aria-orientation={!decorative ? orientation : undefined}
        className={cn(
          baseClasses,
          "bg-[var(--color-warm-200)]",
          className
        )}
        {...props}
      />
    );
  }
);

Separator.displayName = "Separator";

export default Separator;